import moment from "moment-timezone"
/**
 * Format and return date in Humanize format
 * Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 * Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
 export const formatDate = (value, formatting = { month: 'long', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('es-ES', formatting).format(new Date(value))
}

export const formatDateInLine = (value = null) => {
  if (!value) return;
  let dateToFormat = new Date(value);
  return  `${dateToFormat.getDate().toString().padStart(2, "0")}-${(dateToFormat.getMonth() + 1).toString().padStart(2, "0")}-${dateToFormat.getFullYear()}`
}

export function localDateToUTC({ tz = 'America/Mexico_City', date = null, format = '' }) {
  if (!date) return null;
  return moment.tz(
    new Date(date), tz
  ).tz('UTC').format(format)
}

export function getMonthNameEs(month) {
  let months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  return months[month];
}